/** 帮助中心 */
import type { IDataBasic, IPageResponse, IResponse, RequestConfig } from '../interface';
import type { SearchModelType } from '../interface/search';
import { fetch } from '../request';

export interface IHelpDoc extends IDataBasic {
  content: string;
  cover_url: string;
  description: string;
  rank: number;
  status: number;
  title: string;
}

export enum CATEGORY_MODEL_TYPE {
  DOC = 0, // 帮助中心
  LINK = 1, // 企业案例链接1  教程2
}

export interface MagicSchoolDetail {
  id: number;
  column_id: number;
  name: string;
  key: string;
  content: string;
  description: string;
  rank: number;
  seo_title: string;
  seo_keywords: string;
  seo_description: string;
  online_status: number;
  editor_user_id: string;
  editor_name: string;
  is_deleted: boolean;
  create_time: Date;
  update_time: Date;
  cover_path: string;
  cover_url: string;
  is_new: boolean;

  // 文章路径
  path_url: string;
  online_time: string;

  // 直播
  start_time?: Date;
  end_time?: Date;
  jump_url?: string;
}

export interface IHelpCategory extends IDataBasic {
  id: number;
  cover_url: string;
  description: string;
  rank: number;
  status: number;
  outer_id: string; // 标志的唯一 id
  column_type: number; // 栏目类型 0 文档 1链接
  title: string;
  jump_url: string; // 链接跳转地址
  model_type: CATEGORY_MODEL_TYPE;
  online_status: 0; // 在线状态 0 上线 1下线
  magic_school_detail?: MagicSchoolDetail[];
  documents: {
    name: string;
    id: number;
  }[];
  cover_path: string;
  article_num: number; // 用来作假的文章数量
  document_number: number;
  online_document_number: number;
  editor_user_id: null;
  editor_name: null;
  navigation_type: number;
  is_new: boolean;
  subtitle: string;
  // 文章路径
  path_url: string;
}

export enum ColumnType {
  DOC = 0, // 帮助中心
  LINK = 1, // 企业案例链接1  教程2
  LIVE = 2, // 直播
}

export interface IHelpCategoryDoc extends IDataBasic {
  id: number; // 文档id
  column_id: number; // 所属栏目id
  name: string; // 名称
  key: string; // 文档key
  description: string; // 描述
  content: string; // 内容
  online_status: number; // 上架状态状态: 1：下架，0：上架
  rank: number; // 排序，数字越小，排序越靠前
  seo_title: string; // 搜索关键字 seo 用的 title
  seo_keywords: string; // 搜索关键字 seo 用的 keywords
  seo_description: string; // 搜索关键字 seo 用的 description
  editor_user_id: number; // 最近修改人user_id
  editor_name: string; // 最近修改人名称

  cover_path: string;
  cover_url: string;
  is_new: boolean;
  path_url: string; // 文章路径
}

export interface IHelpCategoryMenu extends IDataBasic {
  outer_id: string; // 标识字符
  column_id: number; // 栏目id
  title: string; // 栏目名称
  jump_url: string; // 链接跳转地址
  description: string; // 描述 - 魔珐学院用作路由的 key
  documents: {
    document_id: number; // 文档id
    name: string; // 文档名称
    key: string; // 文档key
    document_card_url: string; // 文档卡片图片
  }[]; // 文档列表
}

export interface IHelpSearch extends IDataBasic {
  model_type: SearchModelType; // 对象类型：0-帮助中心文档，1-企业案例 2 教程
  model_id: string; // 文档id/案例id
  document_key: string; // 文档key
  document_name: string; // 文档名称
  display_content: {
    text: string; // 展示文本
    highlight_text: string; // 高亮文本
    anchor_point_id: number; // 锚点id
  }; // 文档命中内容或文档描述
  display_title: {
    text: string; // 展示文本
    highlight_text: string; // 高亮文本
    anchor_point_id: number; // 锚点id
  }; // 文档命中标题或文档标题
  update_time: string; // 更新时间
  column_id: number; // 栏目id
  column_title: string; // 栏目标题
  image_url?: string; // 图片路径
  video_url?: string; // 视频路径
  preview_video?: string; // 视频预览
  video_cover_url?: string; // 视频封面
  cover_url?: string; // 封面图片
  audio_url?: string; // 音频路径
  is_new?: boolean; // 是否是新文档
  column_outer_id?: string; // 标识字符
}

export interface IHelpFeedBack extends IDataBasic {
  id: number;
  document_id: string; // 文档id
  name: string; // 文档名称
  is_helpful: string; // 是否有用 0 有用 1 无用
  opinions_and_suggestions: string; // 意见和建议
}

export const reqGetDoc = (outer_id: string) =>
  fetch<IResponse<IHelpDoc[]>>('/help_center/documentation/', {
    params: { outer_id },
  });
export const reqGetDocList = (title__icontains?: string) =>
  fetch<IPageResponse<IHelpDoc>>('/help_center/documentation/', {
    params: { page: 1, page_size: 999, title__icontains },
  });

// 获取帮助中心栏目卡片
export const getHelpCategory = (params: { model_type: SearchModelType }) =>
  fetch<IResponse<IHelpCategory[]>>('/help_center/column/', {
    params,
  });

// 获取帮助中心目录
export const getHelpCategoryMenu = (
  params?: { model_type: SearchModelType },
  config?: RequestConfig,
) => {
  return fetch<IResponse<IHelpCategoryMenu[]>>('/help_center/column/index/', {
    params,
    ...config,
  });
};

// 获取帮助中心栏目文档详情
export const getHelpCategoryDoc = (params: {
  id?: number;
  name?: string;
  column_id?: number;
  path_url?: string;
  is_copy?: boolean;
}) =>
  fetch<IResponse<IHelpCategoryDoc[]>>('/help_center/column/document/', {
    params,
  });

export const getAdminHelpCategoryDoc = (
  params: {
    id?: number;
  },
  header: any,
) =>
  fetch<IResponse<IHelpCategoryDoc[]>>('/help_center/admin_column/document/', {
    params,
    credential: false,
    headers: header,
  });

// 帮助中心搜索切割关键词
export const getSegmentWord = (keyword: string) => {
  return fetch<IResponse<string[]>>('/promotion_center/search/segment_word/', {
    params: { keyword },
  });
};

// 帮助中心搜索结果
export const getSearchCategoryResult = (params: {
  keyword: string;
  page: number;
  page_size: number;
}) => {
  return fetch<{
    data: {
      total: number;
      count: number;
      data: IHelpSearch[];
    };
    code: number;
  }>('/promotion_center/search/', {
    params,
  });
};

// 搜索历史获取
export const getSearchHistory = (search_area: string) => {
  return fetch<IResponse<string[]>>('/user_operation/history_search/', {
    params: {
      search_area,
      history_length: 35,
    },
  });
};

// 增加/删除 搜索历史
export const editSearchHistory = (params: {
  search_area?: string;
  search_record?: string;
  is_del?: boolean;
}) => {
  return fetch<IResponse<string[]>>('/user_operation/history_search/', {
    method: 'POST',
    body: {
      ...params,
      history_length: 35,
    },
  });
};

// 创建反馈内容
export const createHelpFeedback = (params: {
  document_id: string;
  name: string;
  is_helpful: string;
  opinions_and_suggestions?: string;
}) => {
  return fetch<IResponse<string>>('/help_center/column/user_evaluation_record/', {
    method: 'POST',
    body: params,
  });
};

// 获取反馈内容
export const getHelpFeedback = (params: { document_id: string }) => {
  return fetch<IResponse<IHelpFeedBack>>('/help_center/column/user_evaluation_record/', {
    params,
  });
};

// 获取热门推荐
export interface IHotRecommend {
  article_url: string;
  data_no: number;
  id: number;
  is_show_new: number;
  paragraph_id: string;
  recommend_title: string;
}
export const getHotRecommend = (params = {}) => {
  return fetch<IResponse<IHotRecommend[]>>('/help_center/document/hot_recommend/', {
    params,
  });
};
